// Back to Top
let btnTop = document.getElementById("toTop");
window.onscroll = function() { scrollFunction() };

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    btnTop.style.display = "flex";
  } else {
    btnTop.style.display = "none";
  }
}

/**
 * Sets a 'header-height' custom property on the root element.
 */
function setHeaderHeight() {
  const header = document.querySelector('.shopify-section-header');
  const headerMenu = document.querySelector('.header__inline-menu');
  if (!header) return;
  let height = parseInt(header.getBoundingClientRect().height) - headerMenu.offsetHeight;
  document.documentElement.style.setProperty('--header-height', `${height}px`);
}

// Update the dimension variables if viewport resized.
window.addEventListener('resize', setHeaderHeight);
window.addEventListener('DOMContentLoaded', setHeaderHeight);


/**
 * Show more product colors
 */
const siblingList = document.querySelector('.siblings-list');
if (siblingList) {
  const siblingButton = document.querySelector('.siblings-show');

  function siblingsLines() {
    const heightLines = [];
    let offset = 0;
    siblingList.querySelectorAll('.siblings__swatch').forEach((item) => {
      if (item.offsetTop > offset) {
        heightLines.push(item.clientHeight);
        offset = item.offsetTop;
      }
    });

    if (heightLines.length > 1) {
      siblingButton.style.display = 'flex';
      siblingList.style.maxHeight = heightLines[0] + heightLines[1] + 'px';
    } else {
      siblingButton.style.display = 'none';
    }
  }

  siblingButton.addEventListener('click', () => {
    siblingList.classList.toggle('active');
    siblingButton.classList.toggle('active');
  });

  siblingsLines();
  window.addEventListener('resize', () => {
    siblingsLines();
  })
}
